import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Checkbox from './checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxGroup = props => {
  const {
    disabled,
    options = [],
    className,
    style,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉

    ...restProps
  } = props;
  const attrs = pickDomAttrs(restProps);
  const [value, onChange] = useControllableValue(props, {
    defaultValue: [],
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const baseClassName = "".concat(prefixClass, "-checkboxGroup");
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: options.map(opt => /*#__PURE__*/_jsx(Checkbox, {
      ...opt,
      disabled: 'disabled' in props ? disabled : opt.disabled,
      checked: value === null || value === void 0 ? void 0 : value.some(v => v === opt.value),
      onChange: checked => {
        if (checked) {
          onChange([...value, opt.value]);
        } else {
          onChange(value === null || value === void 0 ? void 0 : value.filter(v => v !== opt.value));
        }
      }
    }, opt.value))
  });
};
export default CheckboxGroup;